import { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';

import dayjs from 'dayjs';

import "react-datepicker/dist/react-datepicker.css";

import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import TuneIcon from '@mui/icons-material/Tune';
import ClearIcon from '@mui/icons-material/Clear';

import CompareCard from '../components/Dashboard/CompareCard.js';

import FilterCard from '../components/Dashboard/FilterCard.js';
import CompareDrawer from '../components/Drawers/CompareDrawer.js';

import { useTranslation } from "react-i18next";

import {
  handleDayTypeClick,
  handleMultiPeriodClick,
  handleMultiRoutes,
  checkFilterCookies,
  updateFilterCookies,
  deleteFilterCookies
} from '../helpers/filterHelpers.js'

import {
  getUser,
  getUserAgency,
  getAllAgencies,
  getGlobalCompare,
  getDetailedCompare,
  getRoutes
} from '../API';

const ComparePeriods = () => {

  const [t] = useTranslation('common');

  const [user, setUser] = useState('');

  const [agencies, setAgencies] = useState('');
  const [agency, setAgency] = useState('');
  const [userAgency, setUserAgency] = useState('');
  const [loading, setLoading] = useState(0);

  //Reference KPIs

  const [refTrips, setRefTrips] = useState(0);
  const [refKms, setRefKms] = useState(0);
  const [refHours, setRefHours] = useState(0);
  const [refVeh, setRefVeh] = useState(0);
  const [refOtp, setRefOtp] = useState(0);
  const [refOcc, setRefOcc] = useState(0);

  const [refRtTrips, setRefRtTrips] = useState(0);
  const [refPlanTrips, setRefPlanTrips] = useState(0);
  const [refRtKms, setRefRtKms] = useState(0);
  const [refPlanKms, setRefPlanKms] = useState(0);
  const [refRtHours, setRefRtHours] = useState(0);
  const [refPlanHours, setRefPlanHours] = useState(0);

  //Reference Dates
  const [startDate, setStartDate] = useState(new Date().setDate(new Date().getDate() - 1));
  const [endDate, setEndDate] = useState(new Date());
  const [startFormat, setStartFormat] = useState('2023-01-01');
  const [endFormat, setEndFormat] = useState(dayjs().format('YYYY-MM-DD'));

  //Compare Dates
  const [startDateComp, setStartDateComp] = useState(new Date().setDate(new Date().getDate() - 1));
  const [endDateComp, setEndDateComp] = useState(null);
  const [startFormatComp, setStartFormatComp] = useState('');
  const [endFormatComp, setEndFormatComp] = useState('');

  //Compare KPIs
  const [compTrips, setCompTrips] = useState(0);
  const [compKms, setCompKms] = useState(0);
  const [compHours, setCompHours] = useState(0);
  const [compVeh, setCompVeh] = useState(0);
  const [compOtp, setCompOtp] = useState(0);
  const [compOcc, setCompOcc] = useState(0);

  const [compRtTrips, setCompRtTrips] = useState(0);
  const [compPlanTrips, setCompPlanTrips] = useState(0);
  const [compRtKms, setCompRtKms] = useState(0);
  const [compPlanKms, setCompPlanKms] = useState(0);
  const [compRtHours, setCompRtHours] = useState(0);
  const [compPlanHours, setCompPlanHours] = useState(0);

  const [refreshKey, setRefreshKey] = useState(0);

  //Filters
  //const [service, setService] = useState(checkFilterCookies()[0].service ? checkFilterCookies()[0].service : 'tous');
  const [service, setService] = useState('tous');
  //const [period, setPeriod] = useState(checkFilterCookies()[0].period ? checkFilterCookies()[0].period : ['all']);
  const [period, setPeriod] = useState(['all']);
  //const [selectedRoutes, setSelectedRoutes] = useState(checkFilterCookies()[0].route ? checkFilterCookies()[0].route : ['all']);
  const [selectedRoutes, setSelectedRoutes] = useState(['all']);


  const [routes, setRoutes] = useState('');
  const [compareDates, setCompareDates] = useState(false)
  const [showCompare, setShowCompare] = useState(false);

  //Variable used only in Trends
  const [recalcAvg, setRecalcAvg] = useState(false);

  //Filter cards
  const [refStartV, setRefStartV] = useState('2023-01-01');
  const [refEndV, setRefEndV] = useState(dayjs().format('YYYY-MM-DD'));
  const [compStartV, setCompStartV] = useState('');
  const [compEndV, setCompEndV] = useState('');

  const [serviceV, setServiceV] = useState('');
  const [periodV, setPeriodV] = useState('');
  const [routesV, setRoutesV] = useState('');

  //Notifications
  const [error, setError] = useState(false);

  //Drawer
  const [open, setOpen] = useState(false);


  //Translate filters from cookies
  useEffect(() => {

    let serviceCookie = checkFilterCookies()[0].service;
    let periodCookie = checkFilterCookies()[0].period;
    let routesCookie = checkFilterCookies()[0].route;

    //Set card value for service
    if (serviceCookie && (serviceCookie == 'tous' || serviceCookie == 'all' || serviceCookie == t('compareperiods.all'))) {
      setServiceV(t('compareperiods.all'))
    } else if (serviceCookie && (serviceCookie == 'se' || serviceCookie == t('compareperiods.week'))) {
      setServiceV(t('compareperiods.week'))
    } else if (serviceCookie && (serviceCookie == 'fds' || serviceCookie == t('compareperiods.weekends'))) {
      setServiceV(t('compareperiods.weekends'))
    } else {
      setServiceV(t('compareperiods.all'))
    }

    //Set card value for period
    let periodFormat = [];

    if (periodCookie && typeof periodCookie !== 'string') {
      periodCookie.forEach((e) => {
        switch (e) {
          case 'all':
            periodFormat.push(' ' + t('compareperiods.all'));
            break
          case 'morning':
            periodFormat.push(' ' + t('compareperiods.morning'));
            break
          case 'am':
            periodFormat.push(' ' + t('compareperiods.am'));
            break
          case 'offpeak':
            periodFormat.push(' ' + t('compareperiods.offpeak'));
            break
          case 'pm':
            periodFormat.push(' ' + t('compareperiods.pm'));
            break
          case 'evening':
            periodFormat.push(' ' + t('compareperiods.evening'));
            break
        }
      })
    } else if (periodCookie) {
      switch (periodCookie) {
        case 'all':
          periodFormat.push(' ' + t('compareperiods.all'));
          break
        case 'morning':
          periodFormat.push(' ' + t('compareperiods.morning'));
          break
        case 'am':
          periodFormat.push(' ' + t('compareperiods.am'));
          break
        case 'offpeak':
          periodFormat.push(' ' + t('compareperiods.offpeak'));
          break
        case 'pm':
          periodFormat.push(' ' + t('compareperiods.pm'));
          break
        case 'evening':
          periodFormat.push(' ' + t('compareperiods.evening'));
          break
      }
    } else {
      periodFormat = t('compareperiods.all')
    }

    setPeriodV(periodFormat);

    //Set card value for routes
    setRoutesV(routesCookie && routesCookie.includes('all') ? t('compareperiods.all') :
      selectedRoutes == 'all' || selectedRoutes == t('compareperiods.all') ? t('compareperiods.all') :
        selectedRoutes);

  }, [])


  useEffect(() => {

    getAllAgencies()
      .then(response => {
        setAgencies(response);
      })
    getUser()
      .then(response => {
        setUser(response.user);
      })
    getUserAgency().then(response => {
      setUserAgency(response)
    })
    getRoutes(agency)
      .then(response => {
        setRoutes(response);
      });

  }, []);


  useEffect(() => {

    setLoading(1);

    let refResponsePromise, compResponsePromise;

    if (selectedRoutes.includes('all') || selectedRoutes.length === routes.length) {
      refResponsePromise = getGlobalCompare(agency, startFormat, endFormat, service, period);
      if (showCompare == true) {
        compResponsePromise = getGlobalCompare(agency, startFormatComp, endFormatComp, service, period);
      }
    } else {
      refResponsePromise = getDetailedCompare(agency, startFormat, endFormat, service, period, selectedRoutes, t);
      if (showCompare == true) {
        compResponsePromise = getDetailedCompare(agency, startFormatComp, endFormatComp, service, period, selectedRoutes, t);
      }
    }

    Promise.all([refResponsePromise, compResponsePromise])
      .then(([refResponse, compResponse]) => {

        if (refResponse && refResponse[0].plannedtrips !== null) {

          setError(false);

          setRefTrips(refResponse[0].tripspct);
          setRefKms(refResponse[0].kmpct);
          setRefHours(refResponse[0].hourspct);
          setRefVeh(refResponse[0].veh);
          setRefOtp(refResponse[0].otp);
          setRefOcc(refResponse[0].occ);

          setRefRtTrips(refResponse[0].rttrips);
          setRefPlanTrips(refResponse[0].plannedtrips);
          setRefRtKms(refResponse[0].rtvehkms);
          setRefPlanKms(refResponse[0].plannedvehkms);
          setRefRtHours(refResponse[0].rtvehhours);
          setRefPlanHours(refResponse[0].plannedvehhours);
        }


        if (compResponse && compResponse[0].plannedtrips !== null) {

          setError(false);

          setCompTrips(compResponse[0].tripspct);
          setCompKms(compResponse[0].kmpct);
          setCompHours(compResponse[0].hourspct);
          setCompVeh(compResponse[0].veh);
          setCompOtp(compResponse[0].otp);
          setCompOcc(compResponse[0].occ);

          setCompRtTrips(compResponse[0].rttrips);
          setCompPlanTrips(compResponse[0].plannedtrips);
          setCompRtKms(compResponse[0].rtvehkms);
          setCompPlanKms(compResponse[0].plannedvehkms);
          setCompRtHours(compResponse[0].rtvehhours);
          setCompPlanHours(compResponse[0].plannedvehhours);
        }

        setLoading(0);
      })
    // .catch(() => {
    //   setError(true);
    // });


  }, [refreshKey])



  const handleChangeDate = (dates) => {

    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    if (end !== null) {
      let formatstart = dayjs(start).format('YYYY-MM-DD');
      let formatend = dayjs(end).format('YYYY-MM-DD');
      setStartFormat(formatstart);
      setEndFormat(formatend);
      //setRefreshKey1(oldKey => oldKey + 1);
    }

  };

  const handleChangeDateComp = (dates) => {

    const [start, end] = dates;
    setStartDateComp(start);
    setEndDateComp(end);

    if (end !== null) {
      let formatstart = dayjs(start).format('YYYY-MM-DD');
      let formatend = dayjs(end).format('YYYY-MM-DD');
      setStartFormatComp(formatstart);
      setEndFormatComp(formatend);
      setCompareDates(true);
      //setRefreshKey2(oldKey => oldKey + 1);
    }

  };

  function handleAgencySelect(e) {
    setAgency(e.target.value);
  }

  const handleToggle = () => {
    setOpen(!open)
  };

  const clearFilters = () => {

    setStartDate(new Date().setDate(new Date().getDate() - 1));
    setEndDate(null);
    setStartFormat('2023-01-01');
    setEndFormat(dayjs().format('YYYY-MM-DD'));

    setStartDateComp(new Date().setDate(new Date().getDate() - 1));
    setEndDateComp(null);
    setStartFormatComp('');
    setEndFormatComp('');

    setCompTrips(0);
    setCompKms(0);
    setCompHours(0);
    setCompVeh(0);
    setCompOtp(0);
    setCompOcc(0);

    setCompRtTrips(0);
    setCompPlanTrips(0);
    setCompRtKms(0);
    setCompPlanKms(0);
    setCompRtHours(0);
    setCompPlanHours(0);

    setService('tous');
    setPeriod(['all']);
    setSelectedRoutes(['all']);

    setCompareDates(false);
    setShowCompare(false);

    setRefStartV('2023-01-01');
    setRefEndV(dayjs().format('YYYY-MM-DD'));
    setCompStartV('');
    setCompEndV('');
    setServiceV(t('compareperiods.all'));
    setPeriodV(t('compareperiods.all'));
    setRoutesV(t('compareperiods.all'));

    setRefreshKey(oldKey => oldKey + 1);
    deleteFilterCookies();
  };



  const handleFilters = () => {

    //Update filter boxes - Refresh Data - Update cookies

    if (selectedRoutes.length > 0 && period.length > 0) {

      if (compareDates == true) {
        setShowCompare(true);
        setCompStartV(startFormatComp);
        setCompEndV(endFormatComp);
      }

      setRefStartV(startFormat);
      setRefEndV(endFormat);

      //Translate service filter box
      setServiceV(service == 'tous' ? t('compareperiods.all') :
        service == 'se' ? t('compareperiods.week') :
          t('compareperiods.weekends'));

      //Translate period filter box
      let periodFormat = [];
      period.forEach((e) => {
        switch (e) {
          case 'all':
            periodFormat.push(t('compareperiods.all'));
            break
          case 'morning':
            periodFormat.push(' ' + t('compareperiods.morning'));
            break
          case 'am':
            periodFormat.push(' ' + t('compareperiods.am'));
            break
          case 'offpeak':
            periodFormat.push(' ' + t('compareperiods.offpeak'));
            break
          case 'pm':
            periodFormat.push(' ' + t('compareperiods.pm'));
            break
          case 'evening':
            periodFormat.push(' ' + t('compareperiods.evening'));
            break
        }
      })
      setPeriodV(periodFormat);

      setRoutesV(selectedRoutes.includes('all') ? t('compareperiods.all') : selectedRoutes);

      updateFilterCookies(service, period, selectedRoutes);
      setRefreshKey(oldKey => oldKey + 1);
    }

  }



  return user && userAgency && agencies && routes ? (

    <>

      <div className="row justify-content-center ps-1 pe-1">
        <div className="col-sm">
          <h1 id="page-title" className="display-5">{t('compareperiods.title')}</h1>
          {Array.isArray(userAgency) && userAgency.length > 1 ? <div className="row justify-content-center mb-2">
            <h3 id="page-subtitle" className="display-5"><b>{agency != '' ? agency.toUpperCase() : userAgency[0].toUpperCase()}</b> </h3>
          </div> : ''}
        </div>
      </div>

      <div className="container pb-2" style={{ backgroundColor: "#f8f9fa" }}>

        <CompareDrawer
          toggle={handleToggle}
          open={open}

          onChange={handleChangeDate}
          onChangeComp={handleChangeDateComp}

          selected={startDate}
          startDate={startDate}
          endDate={endDate}

          selectedComp={startDateComp}
          startDateComp={startDateComp}
          endDateComp={endDateComp}

          service={service}
          handleDayTypeClick={handleDayTypeClick}

          period={period}
          handleMultiPeriodClick={handleMultiPeriodClick}

          routes={routes}
          selectedRoutes={selectedRoutes}
          setSelectedRoutes={setSelectedRoutes}
          handleMultiRoutes={handleMultiRoutes}

          handleFilters={handleFilters}
          error={error}

          setService={setService}
          setPeriod={setPeriod}

          setRecalcAvg={setRecalcAvg}
          t={t}
        />

        {loading == 0 ? '' :
          <div className="datatablespinner">
            <ReactLoading type={"spin"} color={"#4d0077"} height={225} width={125} />
          </div>}

        <div className="row justify-content-center pt-3">
          <div className="col-lg col-sm-12 text-center">

            {Array.isArray(userAgency) && userAgency.length > 1 ?
              <div className="me-1 border rounded ps-2 pe-2" style={{ backgroundColor: "white" }}>
                <div className="row justify-content-center">
                  <div className="col-lg-4 col-sm-12">
                    <select onChange={(e) => handleAgencySelect(e)} className="form-select form-select-lg mb-3 mt-3">
                      <option defaultValue>Opérateur</option>
                      {userAgency.map((e) => (
                        <option value={e} key={e}
                        >{e}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              : ''}

          </div>
        </div>

        <div className="me-1 border rounded ps-2 pe-2" style={{ backgroundColor: "white" }}>

          <div className="row row-cols-1 row-cols-md-3 g-4 pb-3 justify-content-center align-items-center">

            <div className="col-lg-2 col-md-4 col-6 pt-2">
              <FilterCard
                kpi1={refStartV}
                kpi2={refEndV}
                desc={t('compareperiods.period1')}
              />
            </div>
            <div className="col-lg-2 col-md-4 col-6 pt-2">
              <FilterCard
                kpi1={compStartV}
                kpi2={compEndV}
                desc={t('compareperiods.period2')}
              />
            </div>
            <div className="col-lg-2 col-md-4 col-6 pt-2">
              <FilterCard
                kpi1={serviceV}
                kpi2={''}
                desc={t('compareperiods.days')}
              />
            </div>
            <div className="col-lg-2 col-md-4 col-6 pt-2">
              <FilterCard
                kpi1={periodV !== t('compareperiods.all') ? periodV.join(',') : periodV}
                kpi2={''}
                desc={t('compareperiods.period')}
              />
            </div>
            <div className="col-lg-2 col-md-4 col-6 pt-2">
              <FilterCard
                kpi1={(routesV.length == routes.length || routesV.includes(t('compareperiods.all'))) ? t('compareperiods.all') : (routesV.length < 10 && routesV.length > 0 && routesV.includes(t('compareperiods.all')) == false) ? routesV.join(',') : t('compareperiods.custom')}
                kpi2={''}
                desc={t('compareperiods.routes')}
              />
            </div>
            <div className="col-lg-2 col-md-4 col-6 pt-2 text-center">
            <ButtonGroup orientation="vertical" aria-label="Vertical button group">
                <Button
                  variant="outlined"
                  onClick={handleToggle}
                  disableElevation
                  startIcon={<TuneIcon />}
                  //sx={ { borderRadius: 28 } }
                  style={{ fontWeight: "bold", borderColor: "#dee2e6", backgroundColor: "grey", color: "white" }}>
                  {t('compareperiods.filters')}
                </Button>
                <Button
                  variant="outlined"
                  onClick={clearFilters}
                  disableElevation
                  startIcon={<ClearIcon />}
                  //sx={ { borderRadius: 28 } }
                  style={{ fontWeight: "bold", borderColor: "#dee2e6", backgroundColor: "red", color: "white" }}>
                  {t('compareperiods.clear')}
                </Button>
                </ButtonGroup>
            </div>
          </div>

        </div >

        <div>
          <div className="row justify-content-center pt-1">
            <div className="col-lg-3 col-6 text-center pt-2 h3"><b>{t('compareperiods.period1')}</b></div>
            {showCompare == true ? <div className="col-lg-3 col-6 text-center pt-2 h3"><b>{t('compareperiods.period2')}</b></div> : ''}
          </div>
          <div className="row justify-content-center pt-1">
            <h5 className="text-center">{t('home.kpi.trips')}</h5>
            <CompareCard
              refkpi={refTrips}
              compkpi={''}
              actual={refRtTrips}
              planned={refPlanTrips}
              name={'trips'}
              color={showCompare == true ? refTrips > compTrips ? '#d7f5df' : refTrips < compTrips ? '#fadede' : 'white' : 'white'}
            />
            {showCompare == true ?
              <CompareCard
                refkpi={refTrips}
                compkpi={compTrips}
                actual={compRtTrips}
                planned={compPlanTrips}
                name={'trips'}
                color={showCompare == true ? refTrips < compTrips ? '#d7f5df' : refTrips > compTrips ? '#fadede' : 'white' : 'white'}
              />
              : ''}
          </div>
          <div className="row justify-content-center pt-1">
            <h5 className="text-center">{t('home.kpi.km')}</h5>
            <CompareCard
              refkpi={refKms}
              compkpi={''}
              actual={refRtKms}
              planned={refPlanKms}
              name={'kms'}
              color={showCompare == true ? refKms > compKms ? '#d7f5df' : refKms < compKms ? '#fadede' : 'white' : 'white'}
            />

            {showCompare == true ?
              <CompareCard
                refkpi={refKms}
                compkpi={compKms}
                name={'kms'}
                actual={compRtKms}
                planned={compPlanKms}
                color={showCompare == true ? refKms < compKms ? '#d7f5df' : refKms > compKms ? '#fadede' : 'white' : 'white'}
              />
              : ''}
          </div>
          <div className="row justify-content-center pt-1">
            <h5 className="text-center">{t('home.kpi.hours')}</h5>
            <CompareCard
              refkpi={refHours}
              compkpi={''}
              actual={refRtHours}
              planned={refPlanHours}
              name={'hours'}
              color={showCompare == true ? refHours > compHours ? '#d7f5df' : refHours < compHours ? '#fadede' : 'white' : 'white'}
            />
            {showCompare == true ?
              <CompareCard
                refkpi={refHours}
                compkpi={compHours}
                name={'hours'}
                actual={compRtHours}
                planned={compPlanHours}
                color={showCompare == true ? refHours < compHours ? '#d7f5df' : refHours > compHours ? '#fadede' : 'white' : 'white'}
              />
              : ''}
          </div>
          <div className="row justify-content-center pt-1">
            <h5 className="text-center">{t('compareperiods.kpi.load')}</h5>

            <CompareCard
              refkpi={refOcc}
              compkpi={''}
              actual={refOcc}
              planned={0}
              name={'occ'}
              color={showCompare == true ? refOcc > compOcc ? '#d7f5df' : refOcc < compOcc ? '#fadede' : 'white' : 'white'}
            />

            {showCompare == true ?
              <CompareCard
                refkpi={refOcc}
                compkpi={compOcc}
                name={'occ'}
                actual={compOcc}
                planned={0}
                color={showCompare == true ? refOcc < compOcc ? '#d7f5df' : refOcc > compOcc ? '#fadede' : 'white' : 'white'}
              />
              : ''}
          </div>
          <div className="row justify-content-center pt-1">
            <h5 className="text-center">{t('compareperiods.kpi.otp')}</h5>

            <CompareCard
              refkpi={refOtp}
              compkpi={''}
              actual={refOtp}
              planned={0}
              name={'otp'}
              color={showCompare == true ? refOtp > compOtp ? '#d7f5df' : refOtp < compOtp ? '#fadede' : 'white' : 'white'}
            />

            {showCompare == true ?
              <CompareCard
                refkpi={refOtp}
                compkpi={compOtp}
                name={'otp'}
                actual={compOtp}
                planned={0}
                color={showCompare == true ? refOtp < compOtp ? '#d7f5df' : refOtp > compOtp ? '#fadede' : 'white' : 'white'}
              />
              : ''}
          </div>
          <div className="row justify-content-center pt-1">
            <h5 className="text-center">{t('compareperiods.kpi.veh')}</h5>

            <CompareCard
              refkpi={refVeh}
              compkpi={''}
              actual={refVeh}
              planned={0}
              name={'veh'}
              color={showCompare == true ? refVeh > compVeh ? '#d7f5df' : refVeh < compVeh ? '#fadede' : 'white' : 'white'}
            />

            {showCompare == true ?
              <CompareCard
                refkpi={refVeh}
                compkpi={compVeh}
                name={'veh'}
                actual={compVeh}
                planned={0}
                color={showCompare == true ? refVeh < compVeh ? '#d7f5df' : refVeh > compVeh ? '#fadede' : 'white' : 'white'}
              />
              : ''}
          </div>
        </div>

      </div >

    </>
  ) :
    <div className="container" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="d-flex justify-content-center">
        <div className="row">
          <div className="col-sm">
            <h1 className="display-5">{t('data.loading')}</h1>
            <div className="d-flex justify-content-center">
              <ReactLoading type={"bars"} color={"#4d0077"} height={300} width={175} />
            </div>
          </div>
        </div>
      </div>
    </div>
}
export default ComparePeriods;